import * as AdminService from "../../RainbowSdk/AdminService";
import LogService from "../../CommonSdk/LogService";

const LOG_TAG = "ACTIONS:SANDBOX_ADMIN";

export const createSandBoxUser = (userData) => dispatch => {
    LogService.trace(LOG_TAG, "createSandBoxUser");

    return AdminService.createUser(userData)
        .then((data) => {
            return Promise.resolve(data);
        })
        .catch((errorPayload) => {
            return Promise.reject(errorPayload);
        });
};